import { useContext } from 'react'
import { PrimaryActionValueContext } from './PrimaryActionContext'
import type { PrimaryAction } from './types'

// Read the current page's primary action (the bottom nav's center button). Returns `null` when
// no page has set one — the button is hidden. Read-only consumer; BottomTabBar is the only caller.
export function useGetPrimaryAction(): PrimaryAction | null {
  return useContext(PrimaryActionValueContext)
}
